import { render, staticRenderFns } from "./ResumeTemp2.vue?vue&type=template&id=04f7d38a&scoped=true&"
import script from "./ResumeTemp2.vue?vue&type=script&lang=js&"
export * from "./ResumeTemp2.vue?vue&type=script&lang=js&"
import style0 from "./ResumeTemp2.vue?vue&type=style&index=0&id=04f7d38a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f7d38a",
  null
  
)

export default component.exports